import React from "react";
import styled from "styled-components";
import "@fontsource/ibm-plex-mono";

interface BookProps {
  title: string;
  author: string;
  image: string;
  price: string;
  inStock?: boolean;
}

const BookContainer = styled.div`
  height: 400px;
  width: 214px;
  position: relative;
`;

const BookImage = styled.img<{ inStock?: boolean }>`
  width: 200px;
  height: 296px;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 10px;

  filter: ${({ inStock }) => (inStock === false ? 'grayscale(100%)' : 'none')};
  opacity: ${({ inStock }) => (inStock === false ? 0.5 : 1)};
`;

const DescriptionContainer = styled.div`
  position: absolute;
  top: 304px;
  width: 214px;
  height: 64px;
  left: 0;
`;

const BookTitle = styled.p`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  width: 210px;
  margin: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Author = styled.div`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  opacity: 0.5;
  margin-top: 6px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Price = styled.div`
  color: #ae0404;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 24px;
  font-weight: 700;
  position: absolute;
  top: 372px;
  left: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const OutOfStockOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 296px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-family: "IBM Plex Mono", monospace;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-size: 16px;
  text-align: center;
`;

export const Book: React.FC<BookProps> = ({ title, author, image, price, inStock = true }) => {
  return (
    <BookContainer>
      <BookImage src={image} alt={title} inStock={inStock} />
      {!inStock && <OutOfStockOverlay>Немає в наявності</OutOfStockOverlay>}
      <DescriptionContainer>
        <BookTitle>{title}</BookTitle>
        <Author>{author}</Author>
      </DescriptionContainer>
      <Price>{price}</Price>
    </BookContainer>
  );
};
